import { useQueryClient } from "@tanstack/react-query";
import { matrixQueries } from "@/domains/matrix";

/**
 * Invalidation for the matrix read model.
 *
 * The rail previews what the grid holds, so anything that changes a cell, a row
 * or a column refreshes the list as well. A column resize is the exception: it
 * fires on every drag and changes nothing the rail shows.
 */
export function useMatrixInvalidation(collectionId: string) {
  const queryClient = useQueryClient();

  return {
    invalidateDetail: () => {
      void queryClient.invalidateQueries(matrixQueries.detail(collectionId));
    },
    invalidateDetailAndList: () => {
      void queryClient.invalidateQueries(matrixQueries.detail(collectionId));
      void queryClient.invalidateQueries(matrixQueries.lists());
    },
  };
}
